import React, { useState, Component } from "react";
import styled from "styled-components";




class LeadGenAmount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // some: "",
    };

  }

  // handleSelectOnclick = (amount) => {
  //     let inputString = amount + "<split>" + amount;
  //     window["autosubmit"](inputString);
  //     console.log(amount); //to test
  // }
 

  render() {
    return (
      <LeadGen_MainWrapper>
        {this.props.LeadGenAmount.map((item, i) => {
          return (
            <div className="action-elem" >
              <div className = "amount-title" 
                //onClick={() => this.handleSelectOnclick(item.amount)} 
                onClick={()=>{window['autosubmit'](item.amount)}}
                key={i}>
                {item.amount} 
              </div>
              {item.description == ""?null:
              <div className="sf-tooltip">i
                <span className="sf-tooltiptext">{item.description}</span>
              </div>}
            </div>
          );
        })}



     
       
      </LeadGen_MainWrapper>
    );
  }
}

export default LeadGenAmount;


const LeadGen_MainWrapper = styled.div`
  
  display: block;

  .amount-title{
    display: inline-block
  }

  .sf-tooltip {
    display: inline-block;
    height: 16px;
    width: 16px;
    margin-left: 12px;
    border-radius: 50%;
    border: 1px solid ;
    font-size: 10px;
    line-height:14px;
    font-weight: 600;
   
  }
  
  .sf-tooltip .sf-tooltiptext {
    visibility: hidden;
    width: 150px;
    color: #fff;
    background-color: #444;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    
    /* Position the tooltip */
    position: absolute;
    z-index: 1;
   // left: 50%;
  
  }
  
  .sf-tooltip:hover .sf-tooltiptext {
    visibility: visible;
  }

`